import { render, staticRenderFns } from "./CookiesPolicePopup.vue?vue&type=template&id=36bf0194&scoped=true&"
import script from "./CookiesPolicePopup.vue?vue&type=script&lang=js&"
export * from "./CookiesPolicePopup.vue?vue&type=script&lang=js&"
import style0 from "./CookiesPolicePopup.vue?vue&type=style&index=0&id=36bf0194&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf0194",
  null
  
)

export default component.exports